export const initialWindowMetrics = null;

/**
 * @deprecated
 */
export const initialWindowSafeAreaInsets = null;
//# sourceMappingURL=InitialWindow.js.map